
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import MovementForm from "@/modules/Report/Movements/components/changePopup/MovementForm.vue";
  import MovementEventsLog from "@/modules/Report/Movements/components/changePopup/MovementEventsLog.vue";

  enum TabKeys {
    Form = 'form',
    Events = 'events',
  }

  @Component({
    components: {
      MovementEventsLog,
      MovementForm,
      AppDialog,
    },
  })
  export default class MovementsChangePopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'reports', dialogName: 'reportMovementsChange' };
    addMode = true;
    activeTab = TabKeys.Form;

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    get tabs() {
      let dataTabs = [
        { label: 'Форма',   name: TabKeys.Form,   componentName: 'MovementForm', },
        { label: 'Журнал',  name: TabKeys.Events, componentName: 'MovementEventsLog', },
      ];
      return dataTabs;
    }

    async mounted() {
      this.addMode = !Boolean(this.payloadPopup.movId);

      await this.$nextTick();
      const popupComponent: any = document.querySelector('.movements-popup .el-dialog');
      if (popupComponent) {
        popupComponent.style.height = `${popupComponent.clientHeight}px`;
      }
    }

    async closeAction() {
      if (this.payloadPopup.fromCarPopup) {
        this.$store.commit('car/setProperty', { name: 'displayContent', value: true });
      }
    }

    async onClose() {
      await this.closeAction();
      this.$refs.appDialog.onClose();
    }
  }
